export default "__VITE_ASSET__Dvi4StUc__"